import { useField, useForm } from 'react-final-form'
import { FieldValidator } from 'final-form'
import { Editor, EditorProps } from './Editor'

export type EditorFieldProps = Omit<EditorProps, 'value' | 'onChange'> & {
  name: string
  validate?: FieldValidator<string>
  className?: string
}

export function EditorField({ name, validate, ...props }: EditorFieldProps) {
  const form = useForm()
  const { input, meta } = useField<string>(name, { validate })

  const handleChange = (value: string) => {
    form.change(name, value)
  }

  const errorMessage = meta.error || meta.submitError || props.error

  return (
    <Editor
      value={input.value ?? ''}
      onChange={handleChange}
      onFocus={input.onFocus}
      onBlur={input.onBlur}
      {...props}
      error={Boolean(meta.touched && errorMessage)}
      formHelperText={(meta.touched && errorMessage) || undefined}
      hiddenInputName={name}
    />
  )
}
